<form #mapForm="ngForm" autocomplete="off">
  <mat-form-field  class="fullWidth">
    <mat-label>Alias</mat-label>
    <input maxlength="255" matInput required [(ngModel)]="data.alias" name="alias">
    <mat-error>
      Alias is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <ac-input-container label="Certificate File *">
    <ac-file-picker alternativeName="trusted.certificate"
                    (acChanged)="onFileChange($event)"
                    [filePickerButtonText]="'Browse'">
    </ac-file-picker>
  </ac-input-container>



</form>
